import { Action, createAction } from 'typesafe-actions'
import ApiError from '../../../entities/ApiError'

export const addFailedRequestActionToState = createAction('DOC / FailedRequest / add to state')<{ type: string; error: ApiError }, undefined>()

export const removeFailedRequestActionFromState = createAction('DOC / FailedRequest / remove from state')<Action>()
